export const Sizes = {
  leftBar: 200,
  topBar: 50
};
